export default "__VITE_ASSET__52ff902f__"